/**
 * Mobile search toggle — shows the JS-powered search trigger
 * and hides the no-JS fallback search form.
 */
document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.js-enabled-search-trigger');
  const fallback = document.querySelector('.js-fallback-search');
  if (trigger && fallback) {
    trigger.style.display = 'block';
    fallback.style.display = 'none';
  }
});
